import { useState } from "react";
import { toast } from "sonner";
import { deleteQuestion } from "../services/quizService";

/**
 * useRemoveQuestion
 * Handles deleting a question by id and managing delete state.
 * Usage:
 *   const { deleteState, handleRemoveQuestion } = useRemoveQuestion();
 *   handleRemoveQuestion(index, question, removeFn);
 */
const useRemoveQuestion = () => {
  // store error of each quiz question using thier index as key
  const [deleteState, setDeleteState] = useState({
    isDeleting: false,
    deletingQuestionIndex: null,
  });

  const handleRemoveQuestion = async (index, currentQuestion, remove) => {
    setDeleteState({
      isDeleting: true,
      deletingQuestionIndex: index,
    });

    try {
      if (currentQuestion?.id) {
        await deleteQuestion(currentQuestion.id);
      }
      remove(index);
      toast.success("Question deleted successfully");
    } catch (error) {
      console.error("Error deleting question:", error);
      toast.error("Something went wrong. Unable to delete question.");
    } finally {
      setDeleteState({
        isDeleting: false,
        deletingQuestionIndex: null,
      });
    }
  };

  return {
    deleteState,
    handleRemoveQuestion,
    setDeleteState,
  };
};

export default useRemoveQuestion;